module.exports = __webpack_public_path__ + "img/logo-white.a273b1d1.png";